import React from 'react'
import './_styles.scss'
import Utils from '../../../../../../../../../../../utils/Utils'
import Translator from '../../../../../../../../../../../requests/apa/Translator'
import store from '../../../../../../../../../../../store'
import { MODAL_MATCH_DETAIL, showModal } from '../../../../../../../../../../../actions/modal'

function SinDerechos (props) {
  var homeTeam = props.homeTeam || {}
  var awayTeam = props.awayTeam || {}

  const openDetailMatch = (e) => {
    e.preventDefault()
    const { dateTime, id} = props

    const modalProps = {
      matchData: {
        matchId: id
      }
    }

    store.dispatch(showModal({
      modalType: MODAL_MATCH_DETAIL,
      modalProps
    }))
  }

  return (
    <a className='mc-sd match-card focusable' tabIndex={0} onClick={openDetailMatch}>
     <div className='mc-cd__band'>
        <div className='mc-cd__band mc-cd__band--home' style={{ background: homeTeam.color }} />
        <div className='mc-cd__band mc-cd__band--away' style={{ background: awayTeam.color }} />
      </div>
      
      <p className='mc-sd__text--container'> 
        <span className='mc-sd__label'>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_ficha_texto_${props.status}`), 15)}</span>
        <span className='mc-sd__time'>{props.liveTime}</span>
      </p>

      <p className='mc-sd__comp-name'>{props.competition}</p>
      <p className='mc-sd__comp-group'>{props.competitionGroup}</p>

      <div className='mc-sd__sep' />

      <div className='mc-sd__flag mc-sd__flag--home'>
        <img src={homeTeam.flagUrl} alt={homeTeam.name} />
      </div>
      <p className='mc-sd__team-name mc-sd__team-name--home'>{homeTeam.name}</p>
      <p className='mc-sd__score mc-sd__score--home'>{props.homeScore}</p>

      <div className='mc-sd__flag mc-sd__flag--away'>
        <img src={awayTeam.flagUrl} alt={awayTeam.name} />
      </div>
      <p className='mc-sd__team-name mc-sd__team-name--away'>{awayTeam.name}</p>
      <p className='mc-sd__score mc-sd__score--away'>{props.awayScore}</p>
    </a>
  )
}

export default SinDerechos



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/MatchCard/Components/SinDerechos/index.jsx